// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var GooglePlus = function GooglePlus(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M15.419 7.011H14.07V5.662h-1.349v1.349h-1.349v1.348h1.349v1.349h1.349V8.359h1.349zm-10.119 0v1.618h2.68a2.55 2.55 0 0 1-2.68 2.037 2.982 2.982 0 0 1 0-5.966 2.657 2.657 0 0 1 1.882.728L8.465 4.2A4.526 4.526 0 0 0 5.3 2.964a4.721 4.721 0 0 0 0 9.442 4.355 4.355 0 0 0 4.534-4.613 4.343 4.343 0 0 0-.074-.782z' })
  );
};

GooglePlus.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default GooglePlus;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/GooglePlus.js
// module id = 1037
// module chunks = 1